export default __webpack_public_path__ + "static/media/p2023-34.f5b94c08.jpeg";